import React from 'react';
import { Nav, Container } from 'react-bootstrap';

import './styles.scss';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container fluid>
        <div className="footer__text">
          <span>&copy; {year} SPINS LLC. All rights reserved. * </span>
          <Nav.Link
            href="https://scorecards-public.s3.us-west-2.amazonaws.com/SPINS-Privacy-Policy-2023.pdf"
            target="_blank"
          >
            Privacy Policy
          </Nav.Link>
          {' * '}
          <Nav.Link
            href="https://scorecards-public.s3-us-west-2.amazonaws.com/spins_portal_terms_conditions.pdf"
            target="_blank"
          >
            Terms and Conditions
          </Nav.Link>{' '}
          <span>
            * You may share information with respect to a retailer only with that retailer.
          </span>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
